import { DoorGroupNameFilterValue } from '@hakimo-ui/hakimo/types';

export const DEFAULT_DOOR_GROUP_FILTER_VALUE: DoorGroupNameFilterValue = {
  values: [],
  negative: false,
};
